import React, { useEffect, useState, useRef } from 'react';
const purchases = [{
  name: 'Valentina M.',
  city: 'Buenos Aires',
  initials: 'VM',
  product: 'Megapack Nutrición Carrera Resuelta™',
  time: 'hace 2 min'
}, {
  name: 'Lucía R.',
  city: 'Córdoba',
  initials: 'LR',
  product: 'Sistema Carrera Organizada™',
  time: 'hace 4 min'
}, {
  name: 'Camila S.',
  city: 'Rosario',
  initials: 'CS',
  product: 'Megapack Nutrición Carrera Resuelta™',
  time: 'hace 7 min'
}, {
  name: 'Sofía G.',
  city: 'La Plata',
  initials: 'SG',
  product: 'Biblioteca Premium Nutrición™',
  time: 'hace 10 min'
}, {
  name: 'Martina P.',
  city: 'Mendoza',
  initials: 'MP',
  product: 'Megapack Nutrición Carrera Resuelta™',
  time: 'hace 13 min'
}, {
  name: 'Julieta F.',
  city: 'Tucumán',
  initials: 'JF',
  product: 'Sistema Carrera Organizada™',
  time: 'hace 16 min'
}, {
  name: 'Florencia B.',
  city: 'Santa Fe',
  initials: 'FB',
  product: 'Megapack Nutrición Carrera Resuelta™',
  time: 'hace 19 min'
}, {
  name: 'Agustina L.',
  city: 'Mar del Plata',
  initials: 'AL',
  product: 'Biblioteca Premium Nutrición™',
  time: 'hace 23 min'
}, {
  name: 'Rocío T.',
  city: 'Salta',
  initials: 'RT',
  product: 'Megapack Nutrición Carrera Resuelta™',
  time: 'hace 27 min'
}, {
  name: 'Milagros C.',
  city: 'San Juan',
  initials: 'MC',
  product: 'Sistema Carrera Organizada™',
  time: 'hace 31 min'
}, {
  name: 'Daniela V.',
  city: 'Neuquén',
  initials: 'DV',
  product: 'Megapack Nutrición Carrera Resuelta™',
  time: 'hace 35 min'
}, {
  name: 'Natalia H.',
  city: 'Paraná',
  initials: 'NH',
  product: 'Biblioteca Premium Nutrición™',
  time: 'hace 40 min'
}];
const avatarColors: Record<string, string> = {
  VM: '#0e7490',
  LR: '#7c3aed',
  CS: '#b45309',
  SG: '#065f46',
  MP: '#9f1239',
  JF: '#1d4ed8',
  FB: '#92400e',
  AL: '#0e7490',
  RT: '#7c3aed',
  MC: '#065f46',
  DV: '#b45309',
  NH: '#1d4ed8'
};
const productEmoji: Record<string, string> = {
  'Megapack Nutrición Carrera Resuelta™': '✅',
  'Sistema Carrera Organizada™': '⭐',
  'Biblioteca Premium Nutrición™': '🏆'
};
export function PurchaseNotifications() {
  const [current, setCurrent] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  const indexRef = useRef(0);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    function showNext() {
      setCurrent(indexRef.current);
      setVisible(true);
      timeoutRef.current = setTimeout(() => {
        setVisible(false);
        indexRef.current = (indexRef.current + 1) % purchases.length;
        const nextDelay = 12000 + Math.random() * 6000;
        timeoutRef.current = setTimeout(showNext, nextDelay);
      }, 4000);
    }
    timeoutRef.current = setTimeout(showNext, 8000);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  const purchase = current !== null ? purchases[current] : null;
  if (!purchase) return null;
  const bgColor = avatarColors[purchase.initials] || '#15803d';
  const emoji = productEmoji[purchase.product] || '✅';
  return <div className="fixed bottom-4 left-4 z-50 max-w-[280px]" style={{
    animation: visible ? 'notifIn 0.3s ease-out forwards' : 'notifOut 0.3s ease-in forwards',
    pointerEvents: 'none'
  }} data-id="element-269">
      <div className="flex items-center gap-3 rounded-2xl px-4 py-3" style={{
      backgroundColor: 'rgb(255,255,255)',
      border: '1px solid rgb(220,252,231)',
      boxShadow: 'rgba(0,0,0,0.10) 0px 8px 24px 0px, rgba(34,197,94,0.08) 0px 0px 0px 1px'
    }} data-id="element-270">
        {/* Avatar */}
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-xs font-black text-white" style={{
        backgroundColor: bgColor
      }} data-id="element-271">
          {purchase.initials}
        </div>

        {/* Content */}
        <div className="min-w-0 flex-1" data-id="element-272">
          <p className="text-xs font-black text-gray-900 m-0 truncate" data-id="element-273">
            {purchase.name}
            <span className="font-normal text-gray-400" data-id="element-274"> · {purchase.city}</span>
          </p>
          <p className="text-[11px] text-gray-600 m-0 truncate mt-0.5" data-id="element-275">
            {emoji} {purchase.product}
          </p>
          <div className="flex items-center gap-1 mt-1" data-id="element-276">
            <span className="inline-block w-1.5 h-1.5 rounded-full" style={{
            backgroundColor: 'rgb(34,197,94)'
          }} data-id="element-277" />
            <p className="text-[10px] text-green-600 font-bold m-0" data-id="element-278">
              Compra confirmada · {purchase.time}
            </p>
          </div>
        </div>
      </div>
    </div>;
}